import styled from 'styled-components'

export const SubHeaderContainer = styled('div')`
  width: 100%;
  max-width: 1392px;
  background-color: white;
  padding: 16px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  position: sticky;
  top: 100px;
  z-index: 10;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    padding: 16px 36px;
  }

  @media (min-width: ${({ theme }) => theme.screen.lgMin}) {
    padding: 16px 20px;
  }

  @media (min-width: 1024px) {
    margin-bottom: 30px;
    flex-direction: row;
    ${({ productoLookAndFeel }) => (productoLookAndFeel ? 'border-radius: 0px 0px 8px 8px;' : 'border-radius: 8px;')}

    ${({ isNavResized }) =>
      isNavResized &&
      `width: calc(100% - 48px);
       border-radius: 0px 0px 8px 8px;`};
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    ${({ isNavResized }) => isNavResized && `top: 72px;`};
  }
`

export const StickyBackground = styled('div')`
  @media (min-width: 1024px) {
    width: 100%;
    height: 50px;
    background-color: #edf1f7;
    z-index: 7;
  }

  @media (min-width: ${({ theme }) => theme.screen.xlMin}) {
    top: 143px;
  }
`
